import { gql } from "@apollo/client";

export const GET_TALONARIO_EXISTE_RI_EV = gql`
query getTalonarioExisteRIEV($nroTalonario: String!, $referencia: String!){
    talonarioExisteRIEV (nroTalonario: $nroTalonario, referencia: $referencia) {    
        success,
        error,
        valorEsperado
    }
  }
`;